import { inject } from '@angular/core';
import { CanMatchFn, Router } from '@angular/router';
import { AuthNavigationService } from '@seatix/shared/auth/utils';
import { map } from 'rxjs';
import { RbacService } from '../rbac/rbac.service';
import { waitForSession } from './session-ready';

export const controlHubAuthGuard: CanMatchFn = (route) => {
  const router = inject(Router);
  const authNavigation = inject(AuthNavigationService);
  const rbacService = inject(RbacService);

  // route.path is only the matched config segment (`events` for
  // `/events/creation-steps?x=1`); the navigation carries the full URL. Read
  // it now: once the session settles, this navigation may no longer be current.
  const attemptedUrl = router.currentNavigation()?.extractedUrl;

  return waitForSession().pipe(
    map((session) => {
      if (session === 'anonymous') {
        const returnUrl = attemptedUrl
          ? router.serializeUrl(attemptedUrl)
          : `/${route.path}`;
        authNavigation.setReturnUrl(returnUrl);
        return router.parseUrl('/auth/login');
      }

      const requestedRoute = `/${route.path}`;

      if (!rbacService.canAccessRoute(requestedRoute)) {
        const defaultRoute = rbacService.getDefaultRoute();

        // If the default route is also not accessible, fallback to /welcome
        if (!rbacService.canAccessRoute(defaultRoute)) {
          return router.parseUrl('/welcome');
        }

        return router.parseUrl(defaultRoute);
      }

      return true;
    }),
  );
};
